import React from 'react';
import './SponsorsSection.css';

const SponsorsSection = () => {
  const sponsors = Array.from({ length: 13 }, (_, i) => ({
    src: `/images/sponsor-${i}.${i === 12 ? 'jpg' : 'png'}`,
    alt: `Sponsor ${i + 1}`,
  }));

  return (
    <section className="sponsors-section fade-in">
      <div className="sponsors-container">
        <h2 className="heading-art-deco heading-medium sponsors-title">
          Ils soutiennent the recap
        </h2>
        <div className="sponsors-grid">
          {sponsors.map((s, i) => (
            <div key={i} className="sponsor-logo">
              <img src={s.src} alt={s.alt} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SponsorsSection;
